module.exports = __webpack_public_path__ + "static/media/time.7e3229b2.svg";